import app from './app';
import auth from './auth';
import cross from './cross.js';
export default {
  app,
  auth,
  cross
};

